import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const TreatmentsAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		treatement: yup.string().required().label("Treatement"),
		description: yup.string().nullable().label("Description"),
		category: yup.string().nullable().label("Category"),
		basepriceadjustment: yup.number().nullable().label("Basepriceadjustment"),
		pricemultiplier: yup.number().nullable().label("Pricemultiplier"),
		estimatedtimeminutes: yup.number().nullable().label("Estimatedtimeminutes"),
		instructions: yup.string().nullable().label("Instructions"),
		isactive: yup.string().nullable().label("Isactive"),
		createdat: yup.string().nullable().label("Createdat"),
		updatedat: yup.string().nullable().label("Updatedat")
	});
	
	//form default values
	const formDefaultValues = {
		treatement: '', 
		description: '', 
		category: '', 
		basepriceadjustment: '', 
		pricemultiplier: "((1.00))", 
		estimatedtimeminutes: "((0))", 
		instructions: '', 
		isactive: "((1))", 
		createdat: "(getutcdate())", 
		updatedat: new Date(), 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/treatments`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="TreatmentsAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Add New Treatment"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Treatement *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="treatement"  onChange={formik.handleChange}  value={formik.values.treatement}   label="Treatement" type="text" placeholder="Enter Treatement"        className={inputClassName(formik?.errors?.treatement)} />
                                                <ErrorMessage name="treatement" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Description 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="description"  onChange={formik.handleChange}  value={formik.values.description}   label="Description" type="text" placeholder="Enter Description"        className={inputClassName(formik?.errors?.description)} />
                                                <ErrorMessage name="description" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Category 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="category"  onChange={formik.handleChange}  value={formik.values.category}   label="Category" type="text" placeholder="Enter Category"        className={inputClassName(formik?.errors?.category)} />
                                                <ErrorMessage name="category" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Basepriceadjustment 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="basepriceadjustment"  onChange={formik.handleChange}  value={formik.values.basepriceadjustment}   label="Basepriceadjustment" type="number" placeholder="Enter Basepriceadjustment"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.basepriceadjustment)} />
                                                <ErrorMessage name="basepriceadjustment" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Pricemultiplier 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pricemultiplier"  onChange={formik.handleChange}  value={formik.values.pricemultiplier}   label="Pricemultiplier" type="number" placeholder="Enter Pricemultiplier"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.pricemultiplier)} />
                                                <ErrorMessage name="pricemultiplier" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Estimatedtimeminutes 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="estimatedtimeminutes"  onChange={formik.handleChange}  value={formik.values.estimatedtimeminutes}   label="Estimatedtimeminutes" type="number" placeholder="Enter Estimatedtimeminutes"  min={0}  step="any"    className={inputClassName(formik?.errors?.estimatedtimeminutes)} />
                                                <ErrorMessage name="estimatedtimeminutes" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Instructions 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="instructions"  onChange={formik.handleChange}  value={formik.values.instructions}   label="Instructions" type="text" placeholder="Enter Instructions"        className={inputClassName(formik?.errors?.instructions)} />
                                                <ErrorMessage name="instructions" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Isactive 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="isactive"  onChange={formik.handleChange}  value={formik.values.isactive}   label="Isactive" type="text" placeholder="Enter Isactive"        className={inputClassName(formik?.errors?.isactive)} />
                                                <ErrorMessage name="isactive" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Createdat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="createdat"  onChange={formik.handleChange}  value={formik.values.createdat}   label="Createdat" type="text" placeholder="Enter Createdat"        className={inputClassName(formik?.errors?.createdat)} />
                                                <ErrorMessage name="createdat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Updatedat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="updatedat" value={formik.values.updatedat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.updatedat)}        />
                                                <ErrorMessage name="updatedat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Submit" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
TreatmentsAddPage.defaultProps = {
	primaryKey: 'treatement',
	pageName: 'treatments',
	apiPath: 'treatments/add',
	routeName: 'treatmentsadd',
	submitButtonLabel: "Submit",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Create Record",
	msgAfterSave: "Record added successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default TreatmentsAddPage;
